printPrefixedLines